import axiosInstance from '../helpers/axiosInstance'

const url = storeId => `${process.env.REACT_APP_PLATFORM_URL}/api/v1/stores/${storeId}/allowed-shipping-packages`

// Answers { restricted, candidates, allowed_ids } for the brand in one warehouse.
export const fetchStoreAllowedShippingPackages = async (storeId, warehouseId) => {
  const res = await axiosInstance.get(url(storeId), { params: { warehouse_id: warehouseId } })
  return res.data
}

// An empty list clears the restriction (the brand may use every box again).
export const updateStoreAllowedShippingPackages = async (storeId, warehouseId, shippingPackageIds) => {
  const res = await axiosInstance.put(url(storeId), { warehouse_id: warehouseId, shipping_package_ids: shippingPackageIds })
  return res.data
}
